import { PageBack } from "@/components/elements/PageBack";
import { black } from "@/theme/colors";
import { Stack, Typography } from "@mui/material";
import { FC, ReactNode } from "react";

export type TTopPageProps = {
  title: ReactNode;
  subTitle?: string;
  description?: ReactNode;
  backUrl?: string;
  rightContent?: ReactNode;
  onBack?: () => void;
  enablePageBack?: boolean;
};

export const TopPage: FC<TTopPageProps> = ({ title, subTitle, description, backUrl, enablePageBack = true, rightContent, onBack }) => {
  return (
    <Stack gap={3}>
      {enablePageBack && (
        <Stack mt={0.5}>
          <PageBack backUrl={backUrl} onBack={onBack} />
        </Stack>
      )}
      <Stack direction="row" gap={3} alignItems="center">
        <Stack gap={1} pt={enablePageBack ? 3 : 0} flex={1}>
          <Stack gap={0.5} pb={2}>
            {subTitle && <Typography variant="body14">{subTitle}</Typography>}
            <Typography variant="head24Bold">{title}</Typography>
          </Stack>
          {description && (
            <Typography variant="body14" color={black[70]}>
              {description}
            </Typography>
          )}
        </Stack>
        {rightContent}
      </Stack>
    </Stack>
  );
};
